import { useQuery } from 'react-query';
import { useApiClient } from '../context';
export function useMessageTemplatesQuery(_a) {
    var _b = (_a === void 0 ? {} : _a).enabled, enabled = _b === void 0 ? true : _b;
    var apiClient = useApiClient().portal;
    return useQuery(['messageTemplates'], function () { return apiClient.fetchMessageTemplates(); }, { enabled: enabled });
}
